import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import regionService from "../../services/RegionService";



/* ── Province thunks ─────────────────────────────────────────────────────── */

export const getProvinceList = createAsyncThunk(
    "region/getProvinceList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await regionService.GetProvinceList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to get province list"
            );
        }
    }
);

export const addProvince = createAsyncThunk(
    "region/addProvince",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.AddProvince(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to add province"
            );
        }
    }
);

export const updateProvince = createAsyncThunk(
    "region/updateProvince",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.UpdateProvince(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to update province"
            );
        }
    }
);

/* ── District thunks ─────────────────────────────────────────────────────── */

export const getDistrictList = createAsyncThunk(
    "region/getDistrictList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await regionService.GetDistrictList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to get district list"
            );
        }
    }
);

export const addDistrict = createAsyncThunk(
    "region/addDistrict",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.AddDistrict(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to add district"
            );
        }
    }
);

export const updateDistrict = createAsyncThunk(
    "region/updateDistrict",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.UpdateDistrict(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to update district"
            );
        }
    }
);


/* ── Electorate thunks ───────────────────────────────────────────────────── */

export const getElectorateList = createAsyncThunk(
    "region/getElectorateList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await regionService.GetElectorateList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to get electorate list"
            );
        }
    }
);

export const addElectorate = createAsyncThunk(
    "region/addElectorate",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.AddElectorate(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to add electorate"
            );
        }
    }
);

export const updateElectorate = createAsyncThunk(
    "region/updateElectorate",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.UpdateElectorate(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to update electorate"
            );
        }
    }
);

/* ── Police station thunks ───────────────────────────────────────────────── */

export const getPoliceStationList = createAsyncThunk(
    "region/getPoliceStationList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await regionService.GetPoliceStationList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to get police station list"
            );
        }
    }
);

export const addPoliceStation = createAsyncThunk(
    "region/addPoliceStation",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.AddPoliceStation(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to add police station"
            );
        }
    }
);

export const updatePoliceStation = createAsyncThunk(
    "region/updatePoliceStation",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.UpdatePoliceStation(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to update police station"
            );
        }
    }
);



/* ── Grama Sewaka Division thunks ────────────────────────────────────────── */

export const getGramaList = createAsyncThunk(
    "region/getGramaList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await regionService.GetGramaList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to get grama division list"
            );
        }
    }
);

export const addGrama = createAsyncThunk(
    "region/addGrama",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await regionService.AddGrama(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to add grama division"
            );
        }
    }
);

const one = (payload) => {
    const set = payload?.data?.ResultSet ?? payload?.data ?? null;
    if (Array.isArray(set)) return set[0] || null;
    return set || null;
};

export const getProvinceById = createAsyncThunk(
    "region/getProvinceById",
    async (code, { rejectWithValue }) => {
        try {
            return one(await regionService.GetProvinceById(code));
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || error.message || "Failed to load province"
            );
        }
    }
);

export const getDistrictById = createAsyncThunk(
    "region/getDistrictById",
    async (code, { rejectWithValue }) => {
        try {
            return one(await regionService.GetDistrictById(code));
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || error.message || "Failed to load district"
            );
        }
    }
);

export const getElectorateById = createAsyncThunk(
    "region/getElectorateById",
    async (code, { rejectWithValue }) => {
        try {
            return one(await regionService.GetElectorateById(code));
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || error.message || "Failed to load electorate"
            );
        }
    }
);

export const getPoliceStationById = createAsyncThunk(
    "region/getPoliceStationById",
    async (code, { rejectWithValue }) => {
        try {
            return one(await regionService.GetPoliceStationById(code));
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || error.message || "Failed to load police station"
            );
        }
    }
);

const initialState = {
    provinces: [],
    districts: [],
    electorates: [],
    policeStations: [],
    gramaDivisions: [],
    // One loading flag per list, so a slow fetch on one sub-tab never leaves
    // another showing a spinner it is not waiting on.
    loading: false,               // province list
    districtLoading: false,       // district list
    electorateLoading: false,
    policeStationLoading: false,
    gramaLoading: false,
    saving: false,
    selectedLoading: false,
    error: null,
    success: false,

    successFor: null,
};

const regionSlice = createSlice({
    name: "region",
    initialState,
    reducers: {
        clearRegionError: (state) => {
            state.error = null;
        },

        clearRegionSuccess: (state) => {
            state.success = false;
            state.successFor = null;
        },

        clearRegions: (state) => {
            state.provinces = [];
            state.districts = [];
            state.electorates = [];
            state.policeStations = [];
            state.gramaDivisions = [];
        }
    },

    extraReducers: (builder) => {
        builder

        // Get province list
        .addCase(getProvinceList.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getProvinceList.fulfilled, (state, action) => {
            state.loading = false;
            state.provinces = action.payload;
        })
        .addCase(getProvinceList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to load provinces";
        })

        // Get district list
        .addCase(getDistrictList.pending, (state) => {
            state.districtLoading = true;
            state.error = null;
        })
        .addCase(getDistrictList.fulfilled, (state, action) => {
            state.districtLoading = false;
            state.districts = action.payload;
        })
        .addCase(getDistrictList.rejected, (state, action) => {
            state.districtLoading = false;
            state.error = action.payload || "Failed to load districts";
        })

        // Add / update province
        .addCase(addProvince.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addProvince.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
            state.successFor = 'province';
        })
        .addCase(addProvince.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add province";
        })

        .addCase(updateProvince.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateProvince.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
            state.successFor = 'province';
        })
        .addCase(updateProvince.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update province";
        })

        // Add / update district
        .addCase(addDistrict.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addDistrict.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
            state.successFor = 'district';
        })
        .addCase(addDistrict.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add district";
        })

        .addCase(updateDistrict.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateDistrict.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
            state.successFor = 'district';
        })
        .addCase(updateDistrict.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update district";
        })

        // Get electorate list
        .addCase(getElectorateList.pending, (state) => {
            state.electorateLoading = true;
            state.error = null;
        })
        .addCase(getElectorateList.fulfilled, (state, action) => {
            state.electorateLoading = false;
            state.electorates = action.payload;
        })
        .addCase(getElectorateList.rejected, (state, action) => {
            state.electorateLoading = false;
            state.error = action.payload || "Failed to load electorates";
        })

        // Get police station list
        .addCase(getPoliceStationList.pending, (state) => {
            state.policeStationLoading = true;
            state.error = null;
        })
        .addCase(getPoliceStationList.fulfilled, (state, action) => {
            state.policeStationLoading = false;
            state.policeStations = action.payload;
        })
        .addCase(getPoliceStationList.rejected, (state, action) => {
            state.policeStationLoading = false;
            state.error = action.payload || "Failed to load police stations";
        })

        // Add / update electorate
        .addCase(addElectorate.pending, (state) => {
            state.saving = true; state.error = null; state.success = false;
        })
        .addCase(addElectorate.fulfilled, (state) => {
            state.saving = false; state.success = true; state.successFor = 'electorate';
        })
        .addCase(addElectorate.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add electorate";
        })

        .addCase(updateElectorate.pending, (state) => {
            state.saving = true; state.error = null; state.success = false;
        })
        .addCase(updateElectorate.fulfilled, (state) => {
            state.saving = false; state.success = true; state.successFor = 'electorate';
        })
        .addCase(updateElectorate.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update electorate";
        })

        // Add / update police station
        .addCase(addPoliceStation.pending, (state) => {
            state.saving = true; state.error = null; state.success = false;
        })
        .addCase(addPoliceStation.fulfilled, (state) => {
            state.saving = false; state.success = true; state.successFor = 'police';
        })
        .addCase(addPoliceStation.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add police station";
        })

        .addCase(updatePoliceStation.pending, (state) => {
            state.saving = true; state.error = null; state.success = false;
        })
        .addCase(updatePoliceStation.fulfilled, (state) => {
            state.saving = false; state.success = true; state.successFor = 'police';
        })
        .addCase(updatePoliceStation.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update police station";
        })

        // Grama divisions — list and add only; the backend has no update yet.
        .addCase(getGramaList.pending, (state) => {
            state.gramaLoading = true;
            state.error = null;
        })
        .addCase(getGramaList.fulfilled, (state, action) => {
            state.gramaLoading = false;
            state.gramaDivisions = action.payload;
        })
        .addCase(getGramaList.rejected, (state, action) => {
            state.gramaLoading = false;
            state.error = action.payload || "Failed to load grama divisions";
        })

        .addCase(addGrama.pending, (state) => {
            state.saving = true; state.error = null; state.success = false;
        })
        .addCase(addGrama.fulfilled, (state) => {
            state.saving = false; state.success = true; state.successFor = 'grama';
        })
        .addCase(addGrama.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add grama division";
        })

        // By-id fetches share one flag — only one row is ever being opened.
        .addMatcher(
            (a) => /^region\/get\w+ById\/pending$/.test(a.type),
            (state) => { state.selectedLoading = true; }
        )
        .addMatcher(
            (a) => /^region\/get\w+ById\/(fulfilled|rejected)$/.test(a.type),
            (state) => { state.selectedLoading = false; }
        );
    }
});

export const {
    clearRegionError,
    clearRegionSuccess,
    clearRegions
} = regionSlice.actions;

export default regionSlice.reducer;